angular
	.module('AutoPrequal')
	.controller('tradeinEstimateCtrl', tradeinEstimateCtrl);

tradeinEstimateCtrl.$inject = ['$scope', '$rootScope', 'ScrollFactory', 'DataFactory'];

function tradeinEstimateCtrl($scope, $rootScope, ScrollFactory, DataFactory) {

	$rootScope.progressCurrent = 13;
	$rootScope.progressMobCurrent = 13;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.tradeinEstimate;

	$scope.data = DataFactory.appData.applicant;
	$scope.checkMaxValue = checkMaxValue;

	$scope.tradeinLow = $scope.data.tradein_rough;
	$scope.tradeinHigh = $scope.data.tradein_clean;
	$scope.tradeinAvg = $scope.data.tradein_avg;
	setVehicleRange();

	$scope.$watch(function () {
		return DataFactory.appData.applicant.tradein_rough
	}, function (newVal, oldVal) {
		if (newVal) {
			$scope.tradeinLow = newVal;
			$scope.tradeinHigh = DataFactory.appData.applicant.tradein_clean;
			$scope.tradeinAvg = DataFactory.appData.applicant.tradein_avg;
			setVehicleRange();
		}
	});

	$scope.$watch(function () {
		return DataFactory.appData.applicant.tradein_avg
	}, function (newVal, oldVal) {
		if (newVal) {
			$scope.tradeinAvg = newVal;
			$scope.tradeinHigh = DataFactory.appData.applicant.tradein_clean;
			$scope.tradeinLow = DataFactory.appData.applicant.tradein_rough;
			setVehicleRange();
		}
	});

	$scope.$watch(function () {
		return DataFactory.appData.applicant.tradein_clean
	}, function (newVal, oldVal) {
		if (newVal) {
			$scope.tradeinHigh = newVal;
			$scope.tradeinAvg = DataFactory.appData.applicant.tradein_avg;
			$scope.tradeinLow = DataFactory.appData.applicant.tradein_rough;
			setVehicleRange();
			checkMaxValue();
		} 
	});


	function setVehicleRange() {
		if ($scope.tradeinHigh == 0) {
			if ($scope.tradeinAvg == 0) {
				$scope.tradeinHigh = $scope.tradeinLow;
			}
			else $scope.tradeinHigh = $scope.tradeinAvg;
		}
		if ($scope.tradeinLow > $scope.tradeinHigh) $scope.tradeinHigh = $scope.tradeinLow;
	}

	function checkMaxValue() {
		var value = $scope.Estimate.apTradeinEstimate.$viewValue;
		if (value) {
			value = value.replace(/,|\s/g, "");
			var field = $scope.Estimate.apTradeinEstimate;
			if (Number(value) > Number($scope.tradeinHigh)) {
				field.$setValidity('', false);
				field.$setTouched();
			}
			else field.$setValidity('', true);
		}
	}

	$rootScope.tradeinEstimateNextStep = function () {
		if ($scope.Estimate.$valid) {

			DataFactory.appData.applicant.appState.tradeinEstimate = true;

			DataFactory.setData($scope.data);

			ScrollFactory.showStep("tradeinPayments");
			ScrollFactory.goToStep("tradeinPayments");
			return true;
		}
		else {
			angular.forEach($scope.Estimate.$error, function (field) {
				angular.forEach(field, function (errorField, index) {
					errorField.$setTouched();
					$rootScope.errorNumber = index + 1;
				})
			});
		}
	}

	$scope.prevStep = function () {
		ScrollFactory.showStep("tradeinDetails");
		ScrollFactory.goToStep("tradeinDetails");
	}
}
